module.exports = __webpack_public_path__ + "img/SES_120140001.5fa6ff73.jpg";